import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';
import {delay, distinctUntilChanged, first, Observable, of, switchMap} from 'rxjs';
import { ProjectHttpService } from '@core/services/api-client.generated';
import { IAppState } from '@core/state/state.service';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { catchError, retry } from 'rxjs';
import { createFormValueBehavior } from '@core/utils/form.utils';
import { debounceTime } from 'rxjs/operators';

const projectNameTaken: 'projectNameTaken' = 'projectNameTaken';
const asyncValidationFail: 'asyncValidationFail' = 'asyncValidationFail';
const hasWhitespace: 'hasWhitespace' = 'hasWhitespace';

export class ProjectNameValidator {
  static errorDescription = {
    [projectNameTaken]: 'That project name is already in use. Try another.',
    [asyncValidationFail]:
      'Project name cannot be checked, please try again. If issue persists refresh the page and contact us.',
    [hasWhitespace]: 'Project name cannot start or end with a space.',
    required: 'Project name is required.',
  };

  static createValidator =
    (projectService: ProjectHttpService, store: Store): AsyncValidatorFn =>
    (control: AbstractControl): Observable<ValidationErrors | null> =>
      of(control.value).pipe(
        delay(400),
        switchMap((projectName) =>
          projectService.validateProjectName(projectName).pipe(
            map((isUnique) => (isUnique ? null : { [projectNameTaken]: true })),
            retry(3),
            catchError(() => of({ [asyncValidationFail]: true }))
          )
        ),
        first()
      );
}
